// System
import { useMemo } from 'react';
import { Stack } from '@mui/material';

// Components
import { RHFMultiSelect } from '@Components/hook-form';

// GraphQL
import { useGetPermissionsQuery } from '@Src/generated.graphql';
import { useAviatorRoleDrawer } from '@Modal/hooks/aviatorRoles/useAviatorRoleDrawer';

export const AddRolePermissionsContent = () => {
  const { data, refetch } = useGetPermissionsQuery();
  const { selectedAviatorRoleData } = useAviatorRoleDrawer();
  refetch();

  const availablePermissions = useMemo(() => {
    const selectedPermissionsSet = new Set(selectedAviatorRoleData?.permissions || []);
    return (
      data?.permissions
        ?.filter((permission) => !selectedPermissionsSet.has(permission))
        .map((permission) => ({
          label: permission
            .replace(/_/g, ' ')
            .toLowerCase()
            .replace(/^\w/, (c) => c.toUpperCase()),
          value: permission,
        })) || []
    );
  }, [data, selectedAviatorRoleData]);

  return (
    <Stack>
      <RHFMultiSelect
        name="permissions"
        label="permissions"
        variant="outlined"
        chip
        options={availablePermissions}
      ></RHFMultiSelect>
    </Stack>
  );
};
